<template>
    <div class="animated revealUp">
      <div class="white-wrapper">
        <div class="section-title">
          {{ $t("Offers-Vouchers Consumption summary Report") }}
        </div>
        <div class="mt-3 mb-2">
          <div class="row">
            <div class="col-lg-6 col-xl-4 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    dropDown.cinemas && dropDown.cinemas.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                >
                <multiselect
                  :disabled="isRoleID"
                  :options="dropDown.cinemas"
                  v-model="dropDown.selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder="Select Cinema"
                  @input="onSelectCinema($event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="fromDate">
                        ✖
                      </button> -->
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="fromDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="fromDate ? 'active' : ''">
                    <!-- {{ $t("show") }} -->
                    {{ $t("fromdate") }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="toDate">
                        ✖
                      </button> -->
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="toDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="toDate ? 'active' : ''">
                    <!-- {{ $t("show") }}  -->
                    {{ $t("todate") }}</label
                  >
                </div>
              </div>
            </div>
  
            <div class="col-lg-6 col-xl-2 align-self-center mb-3">
              <button
                class="btn-blue-lg w-100"
                @click.prevent="GetOfferSalesReport('N')"
              >
                {{ $t("fetch") }}
                {{ $t("report") }}
              </button>
            </div>
          </div>
        </div>
  
        <div
        v-if="itemData.length > 0"
          class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
        >
          <div class="mx-1">{{ $t("download") }} as:</div>
          <!-- s -->
          <a
            target="_blank"
            @click="GetOfferSalesReport('Y')"
            title="Download as PDF"
            download
          >
            <img
              class="mx-1"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
            />
          </a>
        </div>
  
        <div>
          <div class="table-scroll">         
            <table class="swc-report-table swc_table_header" border="1" v-if="itemData.length > 0">
  <thead class="bg-lightgrey">
    <tr>
      <th rowspan="2">Category</th>
      <th colspan="">Comp Type</th>
      <th colspan="">Item</th>
      <th colspan="">Quantity</th>
      <th colspan="">Value Before Comp (Gross)</th>
      <th colspan="">Comp Value (Gross)</th>
      <th colspan="">Comp Tax</th>
      <th colspan="">Value After Comp(Gross)</th>
    </tr>
  </thead>
  <template v-for="(categoryData, categoryIndex) in itemData">
    <tr class="distName">
      <th class="text-left" :rowspan="categoryData.offerArray.length + 1">
        {{ categoryData.offerName }}
      </th>
    </tr>
    <template v-for="(fnbData, fnbIndex) in categoryData.offerArray">
      <tr>
       
        <td class="text-right">
          {{ fnbData.offer_name }}
        </td>
        <td class="text-right">
          {{ fnbData.item }}
        </td>
        <td class="text-right">
          {{ fnbData.quantity }}
        </td>
        <td class="text-right">
          {{ +parseFloat(fnbData.t_gross_amount).toFixed(MIN_FRACTION_DIGITS) }}
        </td>
        <td class="text-right">
          {{ +parseFloat(fnbData.t_offer_price).toFixed(MIN_FRACTION_DIGITS) }}
        </td>
        <td class="text-right">
          {{ +parseFloat(fnbData.tax_amount).toFixed(MIN_FRACTION_DIGITS) }}
        </td>
        <td class="text-right">
          {{ +parseFloat(fnbData.gross_amount_after_offer).toFixed(MIN_FRACTION_DIGITS) }}
        </td>
      </tr>
    </template>
    <tr style="background-color: #E8E8E8;">
      <td class="text-left font-weight-bold text-left" colspan="2">Total for {{categoryData.offerName}}</td>
      <td class="text-right font-weight-bold" >
      -
      </td>
      <td class="text-right font-weight-bold" >
      {{categoryData.grandTotal.quantity}}
      </td>
      <td class="text-right font-weight-bold" >
        {{ +parseFloat(categoryData.grandTotal.t_gross_amount).toFixed(MIN_FRACTION_DIGITS)}} 
      </td>
      <td class="text-right font-weight-bold" >
        {{ +parseFloat(categoryData.grandTotal.t_offer_price).toFixed(MIN_FRACTION_DIGITS)}}
      </td>
      <td class="text-right font-weight-bold" >
        {{ +parseFloat(categoryData.grandTotal.tax_amount).toFixed(MIN_FRACTION_DIGITS)}}
      </td>
      <td class="text-right font-weight-bold" >
        {{ +parseFloat(categoryData.grandTotal.gross_amount_after_offer).toFixed(MIN_FRACTION_DIGITS)}}
      </td>
    </tr>
  </template>
  <thead class="bg-lightgrey">
    <tr>
      <th class="text-left" colspan="2">Grand Total</th>
      <th class="text-right" >-</th>
      <td class="text-right font-weight-bold" >{{grandTotaparseFloat}}</td>
      <td class="text-right font-weight-bold" >{{+parseFloat(grandTotal.t_gross_amount).toFixed(MIN_FRACTION_DIGITS)}}</td>
      <td class="text-right font-weight-bold" >{{+parseFloat(grandTotal.t_offer_price).toFixed(MIN_FRACTION_DIGITS)}}</td>
      <td class="text-right font-weight-bold" >{{+parseFloat(grandTotal.tax_amount).toFixed(MIN_FRACTION_DIGITS)}}</td>
      <td class="text-right font-weight-bold" >{{+parseFloat(grandTotal.gross_amount_after_offer).toFixed(MIN_FRACTION_DIGITS)}}</td>
    
    </tr>
  </thead>
</table>
          </div> 
        </div>

        <div style="margin-top: 40px;">
          <div class="table-scroll">         
            <table class="swc-report-table swc_table_header" border="1" v-if="itemData.length > 0">
  <thead class="bg-lightgrey">
    <tr>
      <th >Category</th>
      <th >Comp Type</th>
      <th >Comp Value (Gross)</th>
      <th >Tax Value</th>
   
    </tr>
  </thead>
  <tbody v-for="(categoryData, categoryIndex) in itemData">
    <tr  >
      <th class="text-left font-weight-normal" :rowspan="categoryData.offerArray.length + 1">
        {{ categoryData.offerName }}
      </th>
    </tr>
    <th class="text-left font-weight-normal">{{ categoryData.offerName}}</th>
    <th class="text-right font-weight-normal">
      {{+parseFloat(categoryData.grandTotal.t_offer_price).toFixed(MIN_FRACTION_DIGITS)}}
    </th>
    <th class="text-right font-weight-normal">
      {{+parseFloat(categoryData.grandTotal.tax_amount).toFixed(MIN_FRACTION_DIGITS)}}
    </th>
</tbody>
<thead class="bg-lightgrey">
    <tr>
      <th class="text-left" colspan="2">Total</th>   
      <td class="text-right font-weight-bold" >{{+parseFloat(grandTotal.t_offer_price).toFixed(MIN_FRACTION_DIGITS)}}</td>
      <td class="text-right font-weight-bold" >{{+parseFloat(grandTotal.tax_amount).toFixed(MIN_FRACTION_DIGITS)}}</td>
    </tr>
  </thead>
</table>
          </div> 
        </div>
      <table       
          class="swc-report-table swc_table_header table-scroll"
          border="1"
          v-if="itemData.length === 0"
        >
          <thead class="bg-lightgrey">
            <tr>
              <th rowspan="2">Category</th>
      <th colspan="">Comp Type</th>
      <th colspan="">Item</th>
      <th colspan="">Quantity</th>
      <th colspan="">Value Before Comp (Gross)</th>
      <th colspan="">Comp Value (Gross)</th>
      <th colspan="">Comp Tax</th>
      <th colspan="">Value After Comp(Gross)</th>
                </tr>
        
          </thead>
          <tbody>
            <tr>
              <td colspan="8">
                <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>  
      </div>
    </div>

   
    
  </template>
    
    <script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";
  
  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        itemData: [],
        totalValues: {},
       grandTotal : {}
      
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      const { cinema_id } = this.secureStore.get("USINFO");
      this.getCinemaList(cinema_id);
    },
    watch: {},
    mounted() {},
    methods: {
      moment,
      getCinemaList: function (cinema_id) {
        MasterService.GetCinemas({cine_id: cinema_id})
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function (event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      GetOfferSalesReport(isPdf = "N") {
        this.itemData = [];
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isPdf,
        };
        ReportsService.GetOfferSalesReport(payload)
          .then((response) => {
            const { data } = response;
            console.log("response",response)
            if (data.status && data.Records.length > 0) {
              this.itemData = [...data.Records];
                //console.log("fnbSalesAnalysisData",this.itemData)
                this.grandTotal = data.finalGrandTotal  
                this.totalValues = data.Records.grandTotal
                console.log("totalValues",this.totalValues)
           
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
  </script>
    
    <style>

  
  </style>
    


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/compsByItemsReport.vue